const initialState = {
    switcher: false,
  };
  
  export const switcherReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SWITCHER':
        return {
          ...state,
          switcher: action.payload,
        };
      default:
        return state;
    }
  };